export default function isNumber(something: any): something is number {
    return typeof something === "number" && isFinite(something);
}
